export default "__VITE_ASSET__BR$0Vngz__"